import * as Yup from 'yup'

const formValidationSchema = {}

export default formValidationSchema
